import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Card,
  Group,
  Stack,
  Text,
  TextInput,
  SegmentedControl,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";

function statusColor(status) {
  if (status === 1) return "green";
  if (status === 2) return "gray";
  if (status === 3) return "red";
  return "gray";
}

export default function ProfileList({
  requestInfo = {
    url: `/retrieve-occupational-profiles/`,
    data: {},
  },
  refresh = false,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    scope: "active",
    search_value: "",
    hol: "entire",
    original: "true",
  });

  const reqData = {
    scope: filters.scope,
    search_value: filters.search_value,
    hol: filters.hol === "entire" ? undefined : filters.hol,
    original: filters.original === "entire" ? undefined : filters.original,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      <Stack gap="sm" mb="sm">
        <TextInput
          placeholder={t("search")}
          size="lg"
          value={filters.search_value}
          onChange={(e) =>
            setFilters({ ...filters, search_value: e.target.value })
          }
        />
        <SegmentedControl
          data={[
            { label: t("all"), value: "entire" },
            { label: t("active"), value: "active" },
            { label: t("inactive"), value: "inactive" },
            { label: t("deleted"), value: "deleted" },
          ]}
          value={filters.scope}
          onChange={(value) => setFilters({ ...filters, scope: value })}
          size="xs"
        />
        <Group gap="sm" wrap="wrap">
          <SegmentedControl
            data={[
              { label: "Catalog", value: "true" },
              { label: "All origins", value: "entire" },
              { label: "Non-catalog", value: "false" },
            ]}
            value={filters.original}
            onChange={(value) => setFilters({ ...filters, original: value })}
            size="xs"
          />
          <SegmentedControl
            data={[
              { label: "HOL any", value: "entire" },
              { label: "HOL yes", value: "true" },
              { label: "HOL no", value: "false" },
            ]}
            value={filters.hol}
            onChange={(value) => setFilters({ ...filters, hol: value })}
            size="xs"
          />
        </Group>
      </Stack>
      <PaginatedList
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/profiles/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card key={item.original.id}>
            <Group justify="space-between" align="flex-start">
              <div>
                <Text
                  fw={700}
                  c="dark"
                  component={Link}
                  to={`/profiles/${item.original.id}`}
                >
                  {item.original.original_name}
                </Text>
                {item.original.holland && (
                  <Text size="sm">{item.original.holland}</Text>
                )}
                <Group gap="xs" mt={4}>
                  {item.original.source_year && (
                    <Text size="sm" c="dimmed">
                      {item.original.source_year}
                    </Text>
                  )}
                  {item.original.hol && (
                    <Badge size="xs" variant="outline">
                      HOL
                    </Badge>
                  )}
                  {item.original.original && (
                    <Badge size="xs" variant="light" color="blue">
                      catalog
                    </Badge>
                  )}
                </Group>
              </div>
              {item.original.status_formatted && (
                <Badge color={statusColor(item.original.status)} variant="light">
                  {item.original.status_formatted}
                </Badge>
              )}
            </Group>
          </Card>
        )}
      />
    </div>
  );
}
